import { el } from "../../lib/redom.es.min.js";
import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { DeliveryGroup } from "./delivery-group.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";


export class DeliveryGroupList extends BaseRedomElement {
    config: ICmsDeliverySelectorConfiguration;
    stateManager: DeliverySelectorStateManager;
    translations: any;
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, stateManager: DeliverySelectorStateManager, translations: any) {
        super(config.useShadowRoot);
        this.config = config;
        this.stateManager = stateManager;
        this.translations = translations;
        this.root = config.useShadowRoot ? this.shadowRoot : this;
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const children = [
            this.config.useShadowRoot ? el("link", { rel: "stylesheet", href: this.config.cssFiles.groupList}) : null,
            ...this.stateManager.state.groups.map(g => new DeliveryGroup(this.config, this.stateManager, this.translations, g))
        ];
        
        this.mountArray(this.root, children);
    }
}

customElements.define("delivery-group-list", DeliveryGroupList);